function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Box from './Box';
const UnstyledButton = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Box, _extends({
  ref: ref,
  as: "button",
  type: "button"
}, props, {
  __css: {
    border: 'none',
    background: 'transparent',
    p: 0,
    outline: 'none',
    color: 'inherit',
    boxShadow: 'none',
    textAlign: 'left',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    borderRadius: 0,
    display: 'inline-block',
    cursor: 'default'
  }
})));
UnstyledButton.displayName = 'UnstyledButton';
export default UnstyledButton;